import { defineComponent as _defineComponent } from 'vue';
import draggable from "vuedraggable";
import { ref } from "vue";
import { storeToRefs } from "pinia";
import { useConfig } from "@/composables/config";
import { useUserStore } from "@/stores/userStore";
import { useActivityStore } from "@/stores/activityStore";
import { useRoute } from "vue-router/composables";
import { convertDropData } from "@/stores/activitySetup";
import { useEventStore } from "@/stores/eventStore";
import ContextMenu from "@/components/Common/ContextMenu.vue";
import FlexPanel from "@/components/Panels/FlexPanel.vue";
import ToolBox from "@/components/Panels/ProviderAwareToolBox.vue";
import WorkflowBox from "@/components/Panels/WorkflowBox.vue";
import ActivityItem from "./ActivityItem.vue";
import ActivitySettings from "./ActivitySettings.vue";
import InteractiveItem from "./Items/InteractiveItem.vue";
import UploadItem from "./Items/UploadItem.vue";
import NotificationItem from "./Items/NotificationItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivityBar',
    emits: ["dragstart"],
    setup(__props, { emit }) {
        const { config } = useConfig();
        const route = useRoute();
        const userStore = useUserStore();
        const eventStore = useEventStore();
        const activityStore = useActivityStore();
        const { isAnonymous } = storeToRefs(userStore);
        // sync built-in activities with cached activities
        activityStore.sync();
        // activities from store
        const { activities } = storeToRefs(activityStore);
        // context menu references
        const contextMenuVisible = ref(false);
        const contextMenuX = ref(0);
        const contextMenuY = ref(0);
        // drag references
        const dragTarget = ref(null);
        const dragItem = ref(null);
        // drag state
        const isDragging = ref(false);
        /**
         * Checks if the route of an activitiy is currently being visited and panels are collapsed
         */
        function isActiveRoute(activityTo) {
            return route.path === activityTo && isActiveSideBar("");
        }
        /**
         * Checks if a panel has been expanded
         */
        function isActiveSideBar(menuKey) {
            return userStore.toggledSideBar === menuKey;
        }
        /**
         * Evaluates the drop data and keeps track of the drop area
         */
        function onDragEnter(evt) {
            const eventData = eventStore.getDragData();
            if (eventData) {
                dragTarget.value = evt.target;
                dragItem.value = convertDropData(eventData);
                emit("dragstart", dragItem.value);
            }
            else {
                dragItem.value = null;
            }
        }
        /**
         * Removes the dragged activity when exiting the drop area
         */
        function onDragLeave(evt) {
            if (dragItem.value && dragTarget.value == evt.target) {
                const dragId = dragItem.value.id;
                activities.value = activities.value.filter((a) => a.id !== dragId);
            }
        }
        /**
         * Insert the dragged item into the activities list
         */
        function onDragOver(evt) {
            const target = evt.target.closest(".activity-item");
            if (target && dragItem.value) {
                const targetId = target.id;
                const targetIndex = activities.value.findIndex((a) => `activity-${a.id}` === targetId);
                if (targetIndex !== -1) {
                    const dragId = dragItem.value.id;
                    const targetActivity = activities.value[targetIndex];
                    if (targetActivity && targetActivity.id !== dragId) {
                        const activitiesTemp = activities.value.filter((a) => a.id !== dragId);
                        activitiesTemp.splice(targetIndex, 0, dragItem.value);
                        activities.value = activitiesTemp;
                    }
                }
            }
        }
        /**
         * Tracks the state of activities which expand or collapse the sidepanel
         */
        function onToggleSidebar(toggle) {
            userStore.toggleSideBar(toggle);
        }
        /**
         * Positions and displays the context menu
         */
        function toggleContextMenu(evt) {
            if (evt && !contextMenuVisible.value) {
                evt.preventDefault();
                contextMenuVisible.value = true;
                contextMenuX.value = evt.x;
                contextMenuY.value = evt.y;
            }
            else {
                contextMenuVisible.value = false;
            }
        }
        return { __sfc: true, config, route, userStore, eventStore, activityStore, isAnonymous, emit, activities, contextMenuVisible, contextMenuX, contextMenuY, dragTarget, dragItem, isDragging, isActiveRoute, isActiveSideBar, onDragEnter, onDragLeave, onDragOver, onToggleSidebar, toggleContextMenu, draggable, ContextMenu, FlexPanel, ToolBox, WorkflowBox, ActivityItem, ActivitySettings, InteractiveItem, UploadItem, NotificationItem };
    }
});
